var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_12519_21251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.6665 8.39062C8.99011 8.39062 9.25244 8.12829 9.25244 7.80469C9.25244 7.48108 8.99011 7.21875 8.6665 7.21875C8.3429 7.21875 8.08057 7.48108 8.08057 7.80469C8.08057 8.12829 8.3429 8.39062 8.6665 8.39062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3488 8.39062C11.6724 8.39062 11.9347 8.12829 11.9347 7.80469C11.9347 7.48108 11.6724 7.21875 11.3488 7.21875C11.0252 7.21875 10.7628 7.48108 10.7628 7.80469C10.7628 8.12829 11.0252 8.39062 11.3488 8.39062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9432 8.39062C14.2668 8.39062 14.5292 8.12829 14.5292 7.80469C14.5292 7.48108 14.2668 7.21875 13.9432 7.21875C13.6196 7.21875 13.3573 7.48108 13.3573 7.80469C13.3573 8.12829 13.6196 8.39062 13.9432 8.39062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.6257 8.39062C16.9493 8.39062 17.2117 8.12829 17.2117 7.80469C17.2117 7.48108 16.9493 7.21875 16.6257 7.21875C16.3021 7.21875 16.0398 7.48108 16.0398 7.80469C16.0398 8.12829 16.3021 8.39062 16.6257 8.39062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.6665 10.6836C8.99011 10.6836 9.25244 10.4213 9.25244 10.0977C9.25244 9.77405 8.99011 9.51172 8.6665 9.51172C8.3429 9.51172 8.08057 9.77405 8.08057 10.0977C8.08057 10.4213 8.3429 10.6836 8.6665 10.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.06726 10.6836C6.39087 10.6836 6.6532 10.4213 6.6532 10.0977C6.6532 9.77405 6.39087 9.51172 6.06726 9.51172C5.74366 9.51172 5.48132 9.77405 5.48132 10.0977C5.48132 10.4213 5.74366 10.6836 6.06726 10.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.38489 10.6836C3.70849 10.6836 3.97083 10.4213 3.97083 10.0977C3.97083 9.77405 3.70849 9.51172 3.38489 9.51172C3.06128 9.51172 2.79895 9.77405 2.79895 10.0977C2.79895 10.4213 3.06128 10.6836 3.38489 10.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.3488 10.6836C11.6724 10.6836 11.9347 10.4213 11.9347 10.0977C11.9347 9.77405 11.6724 9.51172 11.3488 9.51172C11.0252 9.51172 10.7628 9.77405 10.7628 10.0977C10.7628 10.4213 11.0252 10.6836 11.3488 10.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.6665 13.0156C8.99011 13.0156 9.25244 12.7533 9.25244 12.4297C9.25244 12.1061 8.99011 11.8438 8.6665 11.8438C8.3429 11.8438 8.08057 12.1061 8.08057 12.4297C8.08057 12.7533 8.3429 13.0156 8.6665 13.0156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.06726 13.0156C6.39087 13.0156 6.6532 12.7533 6.6532 12.4297C6.6532 12.1061 6.39087 11.8438 6.06726 11.8438C5.74366 11.8438 5.48132 12.1061 5.48132 12.4297C5.48132 12.7533 5.74366 13.0156 6.06726 13.0156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M3.38489 13.0156C3.70849 13.0156 3.97083 12.7533 3.97083 12.4297C3.97083 12.1061 3.70849 11.8438 3.38489 11.8438C3.06128 11.8438 2.79895 12.1061 2.79895 12.4297C2.79895 12.7533 3.06128 13.0156 3.38489 13.0156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.3488 13.0156C11.6724 13.0156 11.9347 12.7533 11.9347 12.4297C11.9347 12.1061 11.6724 11.8438 11.3488 11.8438C11.0252 11.8438 10.7628 12.1061 10.7628 12.4297C10.7628 12.7533 11.0252 13.0156 11.3488 13.0156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M8.6665 15.3066C8.99011 15.3066 9.25244 15.0443 9.25244 14.7207C9.25244 14.3971 8.99011 14.1348 8.6665 14.1348C8.3429 14.1348 8.08057 14.3971 8.08057 14.7207C8.08057 15.0443 8.3429 15.3066 8.6665 15.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.06726 15.3066C6.39087 15.3066 6.6532 15.0443 6.6532 14.7207C6.6532 14.3971 6.39087 14.1348 6.06726 14.1348C5.74366 14.1348 5.48132 14.3971 5.48132 14.7207C5.48132 15.0443 5.74366 15.3066 6.06726 15.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M3.38489 15.3066C3.70849 15.3066 3.97083 15.0443 3.97083 14.7207C3.97083 14.3971 3.70849 14.1348 3.38489 14.1348C3.06128 14.1348 2.79895 14.3971 2.79895 14.7207C2.79895 15.0443 3.06128 15.3066 3.38489 15.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.3488 15.3066C11.6724 15.3066 11.9347 15.0443 11.9347 14.7207C11.9347 14.3971 11.6724 14.1348 11.3488 14.1348C11.0252 14.1348 10.7628 14.3971 10.7628 14.7207C10.7628 15.0443 11.0252 15.3066 11.3488 15.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M13.9432 10.6836C14.2668 10.6836 14.5292 10.4213 14.5292 10.0977C14.5292 9.77405 14.2668 9.51172 13.9432 9.51172C13.6196 9.51172 13.3573 9.77405 13.3573 10.0977C13.3573 10.4213 13.6196 10.6836 13.9432 10.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M16.6257 10.6836C16.9493 10.6836 17.2117 10.4213 17.2117 10.0977C17.2117 9.77405 16.9493 9.51172 16.6257 9.51172C16.3021 9.51172 16.0398 9.77405 16.0398 10.0977C16.0398 10.4213 16.3021 10.6836 16.6257 10.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M19.4141 1.11609H17.704V0.585938C17.704 0.262344 17.4416 0 17.118 0C16.7945 0 16.5321 0.262344 16.5321 0.585938V1.11609H14.8525V0.585938C14.8525 0.262344 14.5902 0 14.2666 0C13.943 0 13.6807 0.262344 13.6807 0.585938V1.11609H12.0011V0.585938C12.0011 0.262344 11.7387 0 11.4151 0C11.0915 0 10.8292 0.262344 10.8292 0.585938V1.11609H9.14961V0.585938C9.14961 0.262344 8.88727 0 8.56367 0C8.24008 0 7.97773 0.262344 7.97773 0.585938V1.11609H6.29812V0.585938C6.29812 0.262344 6.03578 0 5.71219 0C5.38859 0 5.12625 0.262344 5.12625 0.585938V1.11609H3.44664V0.585938C3.44664 0.262344 3.1843 0 2.8607 0C2.53711 0 2.27477 0.262344 2.27477 0.585938V1.11609H0.585938C0.262344 1.11609 0 1.37844 0 1.70203V19.4141C0 19.7377 0.262344 20 0.585938 20H19.4141C19.7377 20 20 19.7377 20 19.4141V1.70203C20 1.37844 19.7377 1.11609 19.4141 1.11609ZM18.8281 18.8281H1.17188V17.6085H14.9052C15.0222 17.6082 15.1959 17.5625 15.3103 17.4459L18.8281 14.0797V18.8281ZM15.4912 15.6509V13.294H17.9543L15.4912 15.6509ZM18.8281 12.1221H14.9052C14.5816 12.1221 14.3193 12.3844 14.3193 12.708V16.4366H1.17188V6.01133H18.8281V12.1221ZM18.8281 4.83945H1.17188V2.28797H2.27477V2.85445C2.27477 3.17805 2.53711 3.44039 2.8607 3.44039C3.1843 3.44039 3.44664 3.17805 3.44664 2.85445V2.28797H5.12621V2.85445C5.12621 3.17805 5.38855 3.44039 5.71215 3.44039C6.03574 3.44039 6.29809 3.17805 6.29809 2.85445V2.28797H7.9777V2.85445C7.9777 3.17805 8.24004 3.44039 8.56363 3.44039C8.88723 3.44039 9.14957 3.17805 9.14957 2.85445V2.28797H10.8291V2.85445C10.8291 3.17805 11.0915 3.44039 11.4151 3.44039C11.7387 3.44039 12.001 3.17805 12.001 2.85445V2.28797H13.6806V2.85445C13.6806 3.17805 13.943 3.44039 14.2666 3.44039C14.5902 3.44039 14.8525 3.17805 14.8525 2.85445V2.28797H16.5321V2.85445C16.5321 3.17805 16.7944 3.44039 17.118 3.44039C17.4416 3.44039 17.7039 3.17805 17.7039 2.85445V2.28797H18.8281V4.83945Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.df6c80f00b35fa0ffa7a5b1631775cdc.svg";
export { ForwardRef as ReactComponent };